import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="M6.867 25a12.94 12.94 0 0 0 3.84 4.179 1 1 0 1 1-1.14 1.643 14.94 14.94 0 0 1-4.434-4.824A1 1 0 1 1 6.867 25M16.945 4.673l2.168 3.756a3.5 3.5 0 0 1 5.912.24l2.5 4.33a11 11 0 1 1-19.052 11l-5.25-9.094a3.5 3.5 0 0 1 2.75-5.237l-.42-.726a3.5 3.5 0 0 1 5.379-4.348 3.5 3.5 0 0 1 6.014.079m-3.78.453a1.5 1.5 0 0 0-.55 2.047l3.25 5.63a1 1 0 0 1-.797 1.497l-.111.002a1 1 0 0 1-.824-.5L9.883 6.44a1.5 1.5 0 1 0-2.598 1.501l4.75 8.227a1 1 0 0 1-.798 1.498l-.11.002a1 1 0 0 1-.824-.5l-2.75-4.762a1.5 1.5 0 0 0-2.598 1.5l5.25 9.093a9 9 0 1 0 15.588-9l-2.5-4.331a1.5 1.5 0 1 0-2.598 1.5l1.25 2.166a1 1 0 0 1-.366 1.366 4 4 0 0 0-1.464 5.464 1 1 0 0 1-1.732 1 6 6 0 0 1 1.253-7.524l.119-.1-4.541-7.866a1.5 1.5 0 0 0-2.049-.548M22 2.875c2.68 0 5.156 1.43 6.494 3.75a1 1 0 1 1-1.732 1A5.5 5.5 0 0 0 22 4.875a1 1 0 1 1 0-2"
    />
  </svg>
);
const SvgIconLienWaivers = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconLienWaivers);
export default Memo;
